export function stringToFloat(value) {
  const formattedNumber = value.replace(',', '.');
  if (Number.isNaN(parseFloat(formattedNumber))) {
    return 0.0;
  }
  return Number(parseFloat(formattedNumber).toFixed(2));
}
